import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_testing_flow_based_data_source_for_gridsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { projectIds?: number[], $top?: number, $skip?: number }): Promise<{ result?: { OrderId?: number, OrderClassId?: number, ShipmentId?: number }[], totalCount?: number }> {

    let url = `${environment.backendUrl}api/SalesOrders/datasources/testing_flow_based_data_source_for_grids/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectIds?: number[], $keys: number[] }): Promise<{ result?: { OrderId?: number, OrderClassId?: number, ShipmentId?: number }[] }> {

    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/testing_flow_based_data_source_for_grids/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
}
